import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestapiService } from 'src/app/core/services/restapi.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager'; 
import Utils from 'src/app/core/constants/utils';

@Component({
  selector: 'contract-callback',
  templateUrl: './contract-callback.component.html',
  styleUrls: ['./contract-callback.component.css']
})
export class ContractCallbackComponent implements OnInit {

  constructor(private restapi: RestapiService,
              private route: ActivatedRoute, private gtmService: GoogleTagManagerService ) { }

  contractID: string = '';

  ngAfterViewInit() {
    this.gtmService.pushTag(Utils.gtmEvent('page-load', 'contract-signed-page'));
  }

  ngOnInit(): void {
    this.contractID = this.route.snapshot.params.id;
    // this.updateContractEsignStatus();
  }

  updateContractEsignStatus() {
    const contractDetails = 'customers/contract/db'
    const data = {
      "status": "SUBMITTED",
      "contractId": this.contractID
    }
    this.restapi.putAPI(contractDetails, data).subscribe(
      (data) => {
        if (data.length > 0) {
        }
      },
      (err) => {
        console.log('ERROR: ', err);
      }
    );
  }

}
